import React, { useState } from "react";
import { Modal, Button, Form, Alert, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../Config";

const SignupModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate First Name
    if (!formData.first_name) {
      newErrors.first_name = "First name is required";
    }

    // Validate Last Name
    if (!formData.last_name) {
      newErrors.last_name = "Last name is required";
    }

    // Validate Email or Mobile
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }

    //validate Mobile
    if (!formData.mobile_number) {
      newErrors.mobile_number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.email = "Enter a valid mobile number";
    }

    // Validate Password (requires uppercase, number, and special character)
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (!passwordRegex.test(formData.password)) {
      newErrors.password =
        "Password must be at least 8 characters long and contain an uppercase letter, a number, and a special character";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      setErrorMessage("");
      setSuccessMessage("");

      try {
        var url = API_URL + "auth/signup";
        const response = await axios.post(url, formData);
        setSuccessMessage(response.data.message);
        setFormData({
          email: "",
          password: "",
          first_name: "",
          last_name: "",
          mobile_number: "",
        });
      } catch (error) {
        // Handle any errors
        if (error.response) {
          // The server responded with an error
          console.error("Error response:", error.response.data);

          if (error.response.data.detail === "Username already taken") {
            setErrors(
              "Email is already registered with us.! Please click forgot password."
            );
          } else {
            setErrors("An error occurred. Please try again.");
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Error request:", error.request);
          setErrors("No response from the server. Please try again later.");
        } else {
          // Something else caused the error
          console.error("Error:", error.message);
          setErrors("An unknown error occurred. Please try again.");
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton className="custom-modal-header">
        <Modal.Title>Sign Up</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {successMessage && <Alert variant="success">{successMessage}</Alert>}
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="first_name">
            <FloatingLabel
              controlId="floatingInput"
              label="First Name"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Enter your first name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                isInvalid={!!errors.first_name}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.first_name}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          <Form.Group controlId="last_name">
            <FloatingLabel
              controlId="floatingInput"
              label="Last Name"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Enter your last name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                isInvalid={!!errors.last_name}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.last_name}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          <Form.Group controlId="email">
            <FloatingLabel
              controlId="floatingInput"
              label="Email"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Enter your email or mobile number"
                name="email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          <Form.Group controlId="mobile_number">
            <FloatingLabel
              controlId="floatingInput"
              label="Mobile number"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Enter your mobile number"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleChange}
                isInvalid={!!errors.mobile_number}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobile_number}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          <Form.Group controlId="password">
            <FloatingLabel
              controlId="floatingInput"
              label="Password"
              className="mb-3"
            >
              <Form.Control
                type="password"
                placeholder="Enter your password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="custom-modal-footer">
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="primary"
          type="submit"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Sign Up"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SignupModal;
